module.exports = __webpack_public_path__ + "images/new-nav-loading.636bd0025f8bb8c256e2d174247cad3f.gif";